import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import MessageList from './MessageList';
import MessageCreation from './MessageCreation';

export default class Message extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/messages/:type(sent|received)" component={MessageList} />
        <Route exact path="/messages/create" component={MessageCreation} />
        <Redirect to="/messages/create" />
      </Switch>
    );
  }
}
